const form = {
  url: "https://docs.google.com/forms/d/e/1FAIpQLSdj7hj-lOK2vmwV-0VhvnMWYUwSbxDvlWMxNuNR3TGr3hWccA/formResponse",
  method: "post",
};

export default form;
